// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
// 280 (2026-08-30, na výslovné přání uživatele - "udělej širší sidebar o 20
// px") - bylo 260.
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
